import Reveal from "@/components/base/Reveal";
import { deepDives } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function DeepDiveSection() {
  return (
    <section id="deep-dive" className="w-full border-b border-background-300 bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          index="壹"
          title="深扒精选"
          desc="每一篇只做一件事：把能查到的公开记录按顺序排开，让线索自己指向关系。"
          actionLabel="查看全部深扒"
          actionHref="#archive"
        />

        <div className="grid grid-cols-1 gap-7 md:grid-cols-3 md:gap-6">
          {deepDives.map((item, i) => (
            <Reveal key={item.title} delay={i * 90}>
              <article className="group flex h-full flex-col border-t-2 border-foreground-900 pt-4">
                <a href="#archive" className="flex cursor-pointer flex-col">
                  <div className="relative w-full overflow-hidden rounded-lg border border-background-300">
                    <div className="h-[190px] w-full md:h-[180px] lg:h-[210px]">
                      <img
                        src={item.image}
                        alt={`${item.title} 黑料91内幕 黑料91背后故事`}
                        title={`黑料91深扒 黑料91内幕 ${item.tag}`}
                        className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                      />
                    </div>
                    <span className="absolute right-3 top-3 rounded-md bg-background-50/92 px-2 py-0.5 font-heading text-sm font-black text-primary-600">
                      {item.index}
                    </span>
                  </div>
                </a>

                <div className="mt-4 flex items-center gap-2">
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-500">{item.meta}</span>
                </div>

                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  <a href="#archive" className="cursor-pointer transition-colors hover:text-primary-600">
                    {item.title}
                  </a>
                </h3>

                <p className="mt-2.5 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {item.excerpt}
                </p>

                <a
                  href="#archive"
                  className="mt-4 inline-flex w-fit cursor-pointer items-center gap-1.5 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700 md:text-sm"
                >
                  展开线索
                  <i className="ri-arrow-right-line text-sm" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}